var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSubscript = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FF3CA0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.02 19-3.34-4.88L7.32 19H3.94l4.84-6.84-4.54-6.5h3.38l3.06 4.56 3.02-4.56h3.42l-4.54 6.48L17.42 19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.352 21v-1.072c2.312-1.672 2.744-2.04 2.744-2.568 0-.368-.344-.56-.76-.56-.568 0-1.016.224-1.4.584l-.76-.912c.568-.624 1.416-.888 2.16-.888 1.256 0 2.16.704 2.16 1.776 0 .816-.584 1.512-2.016 2.44h2.056V21z"
}))));
export default SvgGemSubscript;